import React, {Component} from "react"

import Loader from "@irati/utils/services/apollo/Loading/Loader"
import {Item, List, Wrapper} from "@irati/ui/src/Reactions/styled"
import {TextButton} from "@irati/ui/src/Button"
import {PickerTitle} from "@irati/ui/src/Reactions"
import {COMPANY_VALUE, COMPANY_VALUE_FIRST_CHAR} from "@irati/ui/src/Reactions/constants"
import LoadCompanyValues from "@irati/companyvalues/apollo/query/CompanyValues"
import {CompanyValue, StringToReplace} from "@irati/companyvalues/types"
import authentication from "@irati/auth"

interface onSelectInput {
  stringToAppend: string,
  fullString: string,
  reducedString: string
}

interface Props {
  onSelect(obj: onSelectInput): void,
  stringToReplace: StringToReplace
}

class CompanyValuePicker extends Component<Props> {
  addCompanyValueToString = (companyValue: CompanyValue) => {
    const {onSelect, stringToReplace} = this.props

    onSelect({
      stringToAppend: `${COMPANY_VALUE_FIRST_CHAR}${companyValue.tag}`,
      ...stringToReplace
    })
  }

  render() {
    const {stringToReplace} = this.props
    const tenantId = authentication.userTenant().uuid

    return (
      <LoadCompanyValues variables={{limit: 100, tenantId}}>
        {(res) => {
          if (!res.data || !res.data.companyValues) { return null }
          const {results} = res.data.companyValues

          // if the user has no company values set up, then the picker should not show
          if (!res.loading && !results.length) {
            return null
          }

          const filteredCompanyValues = results.filter((result: CompanyValue) => result.tag.includes(stringToReplace.reducedString))
          const companyValuesToRender = filteredCompanyValues.length > 0 ? filteredCompanyValues : results

          return (
            <Wrapper>
              <PickerTitle
                titleValue={stringToReplace.fullString}
                type={COMPANY_VALUE} />
              <List>
                {res.loading && <Loader />}

                {!res.loading &&
                  companyValuesToRender.map((companyValue: CompanyValue) => (
                    <TextButton
                      key={companyValue.uuid}
                      onClick={() => this.addCompanyValueToString(companyValue)}>
                      <Item>{COMPANY_VALUE_FIRST_CHAR}{companyValue.tag}</Item>
                    </TextButton>
                  ))
                }
              </List>
            </Wrapper>
          )
        }}
      </LoadCompanyValues>
    )
  }
}

export default CompanyValuePicker
